// TODO refactor this when folder/file restructuring, abstracting ist's items

import * as React from "react";
import { DATATEST } from "constants/integration";
import { $, merge } from "glamor";
import theme from "styles/theme";
import { formatMessage } from "lib/globalize-util";
import { IconButton, Theme } from "@nuorder/components";
import { ManageTargetsModal } from "./manage-target-modal";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import MenuItem from "material-ui/MenuItem";
import { Target } from "components/icons/assortments/target";
import { RenderedComponent, useTargetWizardContext } from "../context/target-wizard-context";
import { Dispatch, connect } from "react-redux";
import { IStore } from "reducers";
import { TARGET_GROUPS_ID } from "constants/product-collection";
import { List } from "immutable";
import { NewTargetButtonType, NewTargetWizardButton } from "./new-target-wizard-button/new-target-wizard-button";
import { DisplayedGridRows } from "reducers/collection-target/types";
import { FINANCIAL_TARGET_ROW_IDS } from "components/product-collection/product-collection-views/product-collection-target-metrics/constants";
import { updateCollapseModeAction, updateDisplayedRowsAction } from "actions/financial-target/actions";
import { Metrics } from "components/icons/assortments/metrics";
import { Columns } from "components/icons/assortments/columns";
import { ChevronRight } from "@material-ui/icons";
import Checkbox from "material-ui/Checkbox";
import { Menu, Switch } from "@material-ui/core";

const DISPLAY_ROW_OPTIONS = [
    {
        key: FINANCIAL_TARGET_ROW_IDS.TARGET,
        text: "Target",
    },
    {
        key: FINANCIAL_TARGET_ROW_IDS.TOTAL,
        text: "Working Total",
    },
    {
        key: FINANCIAL_TARGET_ROW_IDS.VARIANCE,
        text: "Variance",
    },
    {
        key: FINANCIAL_TARGET_ROW_IDS.VARIANCE_PERCENTAGE,
        text: "Variance %",
    },
];

interface Props {
    isRollupMode: boolean;
}

interface ReduxProps {
    targetGroups: List<Map<string, any>>;
    displayedRows: DisplayedGridRows;
    isCollapseModeOn: boolean;
}

interface ReduxDispatchActions {
    updateDisplayedRows: (value: DisplayedGridRows) => void;
    updateCollapseMode: (value: boolean) => void;
}

const customSwitchStyle = merge(
    $(" .Mui-checked + .MuiSwitch-track", {
        backgroundColor: `${theme.palette.primary1Color} !important`,
    }),
    $(" .MuiSwitch-thumb", {
        color: theme.palette.primary1Color,
    })
);

export const TargetsContainerComponent = ({
    isRollupMode,
    targetGroups,
    displayedRows,
    updateDisplayedRows,
    isCollapseModeOn,
    updateCollapseMode,
}: Props & ReduxProps & ReduxDispatchActions) => {
    const shouldRenderTarget = !isRollupMode;

    const {
        renderedComponent: [renderedComponent, setRenderedComponent],
    } = useTargetWizardContext();

    const [nestedMenuAnchor, setNestedMenuAnchor] = React.useState(null);
    const [nestedCollapseMenuAnchor, setNestedCollapseMenuAnchor] = React.useState(null);
    const [mainMenuAnchor, setMainMenuAnchor] = React.useState(null);

    return (
        shouldRenderTarget && (
            <Theme>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "start",
                        height: "50px",
                        textTransform: "inherit",
                        fontFamily: "inherit",
                        width: "140px",
                        borderRight: "#bdc3c7 solid 2px",
                        borderLeft: "#bdc3c7 solid 2px",
                        borderRadius: 0,
                        padding: "8px 0 8px 12px",
                    }}
                    data-test={DATATEST.ASSORTMENTS.CREATE_TARGET_MODAL}
                >
                    {formatMessage("Targets")}
                    <span style={{ flex: 1 }} />
                    {targetGroups?.size < 1 || !targetGroups?.size ? (
                        <NewTargetWizardButton type={NewTargetButtonType.Icon} />
                    ) : (
                        <>
                            <IconButton
                                onClick={(e) => {
                                    setMainMenuAnchor(e.currentTarget);
                                }}
                                data-test={DATATEST.ASSORTMENTS.FOOTER.TARGETS_VERT_MENU}
                            >
                                <MoreVertIcon />
                            </IconButton>
                            <Menu
                                open={Boolean(mainMenuAnchor)}
                                anchorEl={mainMenuAnchor}
                                onClose={() => {
                                    setMainMenuAnchor(null);
                                }}
                            >
                                <MenuItem
                                    data-test={DATATEST.ASSORTMENTS.FOOTER.MANAGE_TARGETS_MENU}
                                    primaryText={
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Target style={{ marginRight: "6px" }} />
                                            {formatMessage("Manage Targets")}
                                        </div>
                                    }
                                    onClick={() => {
                                        setMainMenuAnchor(null);
                                        setMainMenuAnchor(null);
                                        setNestedCollapseMenuAnchor(null);
                                        setRenderedComponent(RenderedComponent.MANAGE_TARGETS_DIALOG);
                                    }}
                                />
                                <MenuItem
                                    data-test={DATATEST.ASSORTMENTS.FOOTER.DISPLAY_ROWS}
                                    onClick={(e) => {
                                        setNestedMenuAnchor(e.currentTarget);
                                    }}
                                    primaryText={
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Metrics style={{ marginRight: "6px" }} />
                                            {formatMessage("Display Rows")}
                                            <ChevronRight />
                                        </div>
                                    }
                                />
                                <MenuItem
                                    data-test={DATATEST.ASSORTMENTS.FOOTER.DISPLAY_COLUMNS}
                                    onClick={(e) => {
                                        setNestedCollapseMenuAnchor(e.currentTarget);
                                    }}
                                    primaryText={
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Columns style={{ marginRight: "6px" }} />
                                            {formatMessage("Display Columns")}
                                            <ChevronRight />
                                        </div>
                                    }
                                />
                                {/* <MenuItem
                            data-test={DATATEST.ASSORTMENTS.FOOTER.FIT_TO_SPACE}
                            style={{ borderTop: "1px solid rgb(225, 225, 225)" }}
                            primaryText={
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <FitToSpace style={{ marginRight: "6px" }} />
                                    {formatMessage("Fit to space")}
                                </div>
                            }
                        /> */}
                            </Menu>
                            <Menu
                                open={Boolean(nestedMenuAnchor)}
                                anchorEl={nestedMenuAnchor}
                                onClose={() => {
                                    setMainMenuAnchor(null);
                                    setNestedMenuAnchor(null);
                                    setNestedCollapseMenuAnchor(null);
                                }}
                                anchorOrigin={{ horizontal: "right", vertical: "top" }}
                            >
                                {DISPLAY_ROW_OPTIONS.map((option) => {
                                    const isOptionDisabled =
                                        displayedRows[option.key] &&
                                        Object.keys(displayedRows).every(
                                            (rowKey) => rowKey === option.key || !displayedRows[rowKey]
                                        );

                                    return (
                                        <MenuItem
                                            key={option.key}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                updateDisplayedRows({
                                                    ...displayedRows,
                                                    [option.key]: !displayedRows[option.key],
                                                });
                                            }}
                                            disabled={isOptionDisabled}
                                            primaryText={
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Checkbox
                                                        disabled={isOptionDisabled}
                                                        color="primary"
                                                        checked={displayedRows[option.key]}
                                                        style={{ width: "auto" }}
                                                    />
                                                    <div>{formatMessage(option.text)}</div>
                                                </div>
                                            }
                                        />
                                    );
                                })}
                            </Menu>
                            <Menu
                                open={Boolean(nestedCollapseMenuAnchor)}
                                anchorEl={nestedCollapseMenuAnchor}
                                onClose={() => {
                                    setMainMenuAnchor(null);
                                    setNestedMenuAnchor(null);
                                    setNestedCollapseMenuAnchor(null);
                                }}
                                anchorOrigin={{ horizontal: "right", vertical: "top" }}
                            >
                                <MenuItem
                                    key="collapse"
                                    onClick={(e) => {}}
                                    primaryText={
                                        <div
                                            {...customSwitchStyle}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <div>{formatMessage("Collapse all")}</div>
                                            <Switch
                                                color="primary"
                                                checked={isCollapseModeOn}
                                                style={{ width: "auto" }}
                                                onChange={(_, newValue) => {
                                                    updateCollapseMode(newValue);
                                                }}
                                            />
                                        </div>
                                    }
                                />
                            </Menu>
                        </>
                    )}
                </div>
                {renderedComponent === RenderedComponent.MANAGE_TARGETS_DIALOG && <ManageTargetsModal />}
            </Theme>
        )
    );
};

const mapStateToProps = (state: IStore) => {
    const targetGroups = state.mutate.snapshots.get(TARGET_GROUPS_ID);
    const displayedRows = state.financialTarget.displayedRows;
    return {
        targetGroups,
        displayedRows,
        isCollapseModeOn: state.financialTarget.isCollapseModeOn,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<IStore>) => {
    const updateDisplayedRows = (value: DisplayedGridRows) => dispatch(updateDisplayedRowsAction(value));
    const updateCollapseMode = (value: boolean) => dispatch(updateCollapseModeAction(value));
    return { updateDisplayedRows, updateCollapseMode };
};

export const TargetsContainer = connect<ReduxProps, ReduxDispatchActions, Props>(
    mapStateToProps,
    mapDispatchToProps
)(TargetsContainerComponent);
